import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VacationData } from './vacation-modal.interface';

@Component({
  selector: 'app-vacation-modal',
  templateUrl: './vacation-modal.component.html',
  styleUrls: ['./vacation-modal.component.scss']
})
export class VacationModalComponent implements OnInit {
  @Input() personName: string = '';
  @Input() vacations: VacationData[] = [];
  @Input() isSaving: boolean = false;
  @Input() maxLength: number = 255;
  
  @Output() editVacation = new EventEmitter<VacationData>();
  @Output() deleteVacation = new EventEmitter<string>();
  @Output() createVacation = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<VacationData>();

  formVacation: FormGroup;
  
  // Colunas da tabela
  displayedColumns: string[] = ['description', 'startDate', 'endDate', 'actions'];

  constructor() {
    this.formVacation = new FormGroup({
      id: new FormControl(''),
      personId: new FormControl(''),
      description: new FormControl('', Validators.maxLength(this.maxLength)),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    // Configurar personId se necessário
    if (this.formVacation.get('personId')?.value) {
      this.formVacation.get('personId')?.setValue(this.formVacation.get('personId')?.value);
    }
  }

  get vacationDescription() {
    return this.formVacation.get('description');
  }

  get remainingCharacters(): number {
    const currentLength = this.vacationDescription?.value?.length || 0;
    return this.maxLength - currentLength;
  }

  onEdit(vacation: VacationData): void {
    this.editVacation.emit(vacation);
  }

  onDelete(id: string): void {
    this.deleteVacation.emit(id);
  }

  onCreate(): void {
    this.createVacation.emit();
  }

  onSubmit(): void {
    if (this.formVacation.valid) {
      const formData: VacationData = {
        id: this.formVacation.get('id')?.value,
        personId: this.formVacation.get('personId')?.value,
        description: this.formVacation.get('description')?.value,
        startDate: this.formVacation.get('startDate')?.value,
        endDate: this.formVacation.get('endDate')?.value
      };
      this.submitForm.emit(formData);
    }
  }

  resetForm(): void {
    this.formVacation.reset();
  }

  patchForm(vacation: VacationData): void {
    this.formVacation.patchValue(vacation);
  }

  formatDate(date: string | Date): string {
    if (!date) return '';
    
    try {
      let d: Date;
      
      if (date instanceof Date) {
        d = date;
      } else if (typeof date === 'string') {
        // Tentar diferentes formatos de data
        if (date.includes('-')) {
          // Formato ISO (YYYY-MM-DD)
          d = new Date(date);
        } else if (date.includes('/')) {
          // Formato brasileiro (DD/MM/YYYY)
          const parts = date.split('/');
          if (parts.length === 3) {
            d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
          } else {
            d = new Date(date);
          }
        } else {
          d = new Date(date);
        }
      } else {
        return '';
      }
      
      // Verificar se a data é válida
      if (isNaN(d.getTime())) {
        return 'Data inválida';
      }
      
      return d.toLocaleDateString('pt-BR');
    } catch (error) {
      return 'Erro ao formatar data';
    }
  }
}
